import React from 'react';

import { PageContainer } from '../../../shared/ui';

const YowanPublicLayout = ({ children }) => {
  return (
    <PageContainer as="div" className="yowan-layout">
      {children}
    </PageContainer>
  );
};

export default YowanPublicLayout;
